import React from 'react';

import { ActivityCodes } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/ActivityCodes/ActivityCodes';
import { ActivityForwardFragnet } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/ActivityForwardFragnet/ActivityForwardFragnet';
import { ActivityFragnet } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/ActivityFragnet/ActivityFragnet';
import { Assignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Assignee/Assignee';
import { BaselineEndDate } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/BaselineEndDate/BaselineEndDate';
import { BaselineStartDate } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/BaselineStartDate/BaselineStartDate';
import { CardActivity } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/CardActivity/CardActivity';
import { CardType } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/CardType/CardType';
import { Cluster } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Cluster/Cluster';
import { CompletionPlanSegment } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/CompletionPlanSegment/CompletionPlanSegment';
import { Duration } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Duration/Duration';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { FinishDate } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/FinishDate/FinishDate';
import { Float } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Float/Float';
import { HasAttachments } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/HasAttachments/HasAttachments';
import { HasComments } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/HasComments/HasComments';
import { Important } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Important/Important';
import { LagLead } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/LagLead/LagLead';
import { RelatedActivity } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/RelatedActivity/RelatedActivity';
import { ResourceName } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/ResourceName/ResourceName';
import { ResourceType } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/ResourceType/ResourceType';
import { RiskIndicators } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/RiskIndicators/RiskIndicators';
import { SearchByName } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/SearchByName/SearchByName';
import { StartDate } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/StartDate/StartDate';
import { Status } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Status/Status';
import { SubmittedCompletion } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/SubmittedCompletion/SubmittedCompletion';
import { Tags } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Tags/Tags';
import { TrackedActivity } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/TrackedActivity/TrackedActivity';
import { UpdatedBy } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/UpdatedBy/UpdatedBy';
import { Urgent } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Urgent/Urgent';
import { Wbs } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Wbs/Wbs';
import { WbsLevel } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/WbsLevel/WbsLevel';

export const Filters = ({ logic, ui, api }) => {
    return (
        <div className={classes.filtersContainer}>
            <CardActivity
                options={logic.fieldsOptions.cardActivityTypeOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <Assignee onFiltersChanged={logic.onFiltersChanged} isLoading={api.assigneeOptions.isLoading} />
            <Status
                options={logic.fieldsOptions.statusOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <FinishDate onFiltersChanged={logic.onFiltersChanged} />
            <RiskIndicators
                options={logic.fieldsOptions.riskIndicatorsOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <Important
                options={logic.fieldsOptions.importantOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <Urgent
                options={logic.fieldsOptions.cardUrgentOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <Tags
                options={logic.fieldsOptions.tagsOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <ActivityCodes
                options={logic.fieldsOptions.activityCodesOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <Wbs onFiltersChanged={logic.onFiltersChanged} />
            <SearchByName onFiltersChanged={logic.onFiltersChanged} />

            {/*Optional Filters*/}
            <BaselineStartDate
                isSelected={ui.state.customizeFilterOptions.baselineStartDate.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <BaselineEndDate
                isSelected={ui.state.customizeFilterOptions.baselineEndDate.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <ActivityFragnet
                isSelected={ui.state.customizeFilterOptions.activityFragnet.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <ActivityForwardFragnet
                isSelected={ui.state.customizeFilterOptions.activityForwardFragnet.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <CardType
                isSelected={ui.state.customizeFilterOptions.cardType.isSelected}
                options={logic.fieldsOptions.typeCardOptions}
                isLoading={api.boardInit.isLoading}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <CompletionPlanSegment
                isSelected={ui.state.customizeFilterOptions.completionPlanSegment.isSelected}
                options={logic.fieldsOptions.completionPlanSegmentOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <Duration
                isSelected={ui.state.customizeFilterOptions.duration.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <Float
                isSelected={ui.state.customizeFilterOptions.float.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <HasAttachments
                isSelected={ui.state.customizeFilterOptions.hasAttachments.isSelected}
                options={logic.fieldsOptions.hasAttachmentsOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <HasComments
                isSelected={ui.state.customizeFilterOptions.hasComments.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <LagLead
                isSelected={ui.state.customizeFilterOptions.lagLead.isSelected}
                options={logic.fieldsOptions.lagLeadOptions}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <RelatedActivity
                isSelected={ui.state.customizeFilterOptions.relatedActivity.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <ResourceType
                isSelected={ui.state.customizeFilterOptions.resourceType.isSelected}
                options={logic.fieldsOptions.resourceTypeOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <StartDate
                isSelected={ui.state.customizeFilterOptions.startDate.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <SubmittedCompletion
                isSelected={ui.state.customizeFilterOptions.submittedCompletion.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <TrackedActivity
                isSelected={ui.state.customizeFilterOptions.trackedActivity.isSelected}
                options={logic.fieldsOptions.trackedActivityOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <UpdatedBy
                isSelected={ui.state.customizeFilterOptions.updatedBy.isSelected}
                options={logic.fieldsOptions.updatedByOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <WbsLevel
                isSelected={ui.state.customizeFilterOptions.wbsLevel.isSelected}
                onFiltersChanged={logic.onFiltersChanged}
            />
            <ResourceName
                isSelected={ui.state.customizeFilterOptions.resourceName.isSelected}
                options={logic.fieldsOptions.resourceNameOptions}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
            <Cluster
                isSelected={ui.state.customizeFilterOptions.cluster.isSelected}
                options={logic.fieldsOptions.clusters}
                onFiltersChanged={logic.onFiltersChanged}
                isLoading={api.boardInit.isLoading}
            />
        </div>
    );
};
